import { Component, OnInit, Input } from '@angular/core';
import { Quotes } from '@models/models';

@Component({
	selector: 'quote-view-fixed',
	template: require('./quote-view-fixed.html'),
	styles: [require('./quote-view-fixed.scss')]
})
export class QuoteViewFixedComponent implements OnInit {
	@Input() products;
	@Input('company') company: any;
	@Input('isClientPortal') isClientPortal = false;
	@Input('data') data: Quotes;
	@Input('imgSrc') imgSrc = '';
	@Input('userCurrencySymbol') userCurrencySymbol: any;

	constructor() {}

	ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quote/quote-view-fixed/quote-view-fixed.ts